import _extends from "@babel/runtime-corejs3/helpers/extends";
import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/map";
import React, { useMemo, Children } from 'react';
import ReactDOM from 'react-dom';
import { useStyles, StyleSheet } from '@rexlabs/styling';
import { PortalTarget } from '@rexlabs/portal';
import { useOverlay, Overlay } from '@rexlabs/overlay';
import { TransitionList } from '@rexlabs/animation';
var defaultStyles = StyleSheet({
  overlay: {
    display: 'flex',
    justifyContent: 'center'
  }
});

function DialogTargetInner(_ref) {
  var children = _ref.children,
      config = _ref.config;

  var _useOverlay = useOverlay(),
      setShow = _useOverlay.setShow;

  var s = useStyles(defaultStyles);
  var chld = Children.toArray(children);
  var numberChildren = chld.length;
  var transitionConfig = useMemo(function () {
    var _context;

    return _concatInstanceProperty(_context = []).call(_context, _toConsumableArray(config), [{
      leave: {
        pointerEvents: 'none'
      },
      onStart: function onStart() {
        if (numberChildren <= 0) {
          setShow(false);
        }
      }
    }]);
  }, [numberChildren, config, setShow]);
  return /*#__PURE__*/React.createElement(TransitionList, {
    configs: transitionConfig
  }, _mapInstanceProperty(chld).call(chld, function (child, index) {
    return /*#__PURE__*/React.createElement(Overlay, _extends({}, s('overlay'), {
      key: index
    }), /*#__PURE__*/React.createElement("div", null, child));
  }));
}

var slideUpConfig = ['slideUp'];
var fadeConfig = ['fade'];
export function DialogTarget(_ref2) {
  var _ref2$name = _ref2.name,
      name = _ref2$name === void 0 ? 'dialogs' : _ref2$name;
  // We have to re-portal these elements to the document.body so that
  // the z-index for the overlay can work correctly
  return /*#__PURE__*/ReactDOM.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(PortalTarget, {
    name: "".concat(name, "-slide")
  }, function (_ref3) {
    var children = _ref3.children;
    return /*#__PURE__*/React.createElement(DialogTargetInner, {
      config: slideUpConfig
    }, children);
  }), /*#__PURE__*/React.createElement(PortalTarget, {
    name: "".concat(name, "-fade")
  }, function (_ref4) {
    var children = _ref4.children;
    return /*#__PURE__*/React.createElement(DialogTargetInner, {
      config: fadeConfig
    }, children);
  })), document.body);
}